import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {PlaceholderModule, PrimaryButtonComponent} from '@q9elements/ui-kit/components';

interface LicenseTextMapping {
  text: string;
  subText: string;
}

@Component({
  selector: 'license-error',
  template: `
    <q9-placeholder>
      <q9-placeholder-animation [animation]="'paid'"></q9-placeholder-animation>
      <span q9PlaceholderText>{{ text | translate }}</span>
      <span q9PlaceholderSubtext>{{ subText | translate }}</span>
      <q9-primary-button class="learn-more-btn" (click)="learnMoreClicked()">
        {{ 'CORE.GENERAL.LEARN_MORE' | translate }}
      </q9-primary-button>
    </q9-placeholder>
  `,
  standalone: true,
  imports: [PlaceholderModule, TranslateModule, PrimaryButtonComponent],
  styleUrls: ['./license-error.component.scss']
})
export class LicenseErrorComponent implements OnInit {
  private route = inject(ActivatedRoute);

  protected text = 'DEPENDENCY_TREE.NOT_AVAILABLE_TEXT';
  protected subText = 'DEPENDENCY_TREE.NOT_AVAILABLE_SUBTEXT';

  private readonly licenseTextMappings: Record<string, LicenseTextMapping> = {
    orgDependencyExplorer: {
      text: 'DEPENDENCY_TREE.NOT_AVAILABLE_TEXT',
      subText: 'DEPENDENCY_TREE.NOT_AVAILABLE_SUBTEXT'
    },
    codeSearch: {
      text: 'CODE_SEARCH.NOT_AVAILABLE_TEXT',
      subText: 'CODE_SEARCH.NOT_AVAILABLE_SUBTEXT'
    },
    systemModels: {
      text: 'LICENSE.SYSTEM_MODELS_TITLE',
      subText: 'LICENSE.SYSTEM_MODELS_DESCRIPTION'
    },
    orgMetadataDictionary: {
      text: 'LICENSE.METADATA_DICTIONARY_TITLE',
      subText: 'LICENSE.METADATA_DICTIONARY_DESCRIPTION'
    }
  };

  ngOnInit(): void {
    this.generateErrorMessage();
  }

  private generateErrorMessage(): void {
    const licenseFlag = this.route.snapshot.queryParamMap.get('licenseFlag');
    const context = this.route.snapshot.queryParamMap.get('context');

    if (!licenseFlag) {
      console.warn('LicenseErrorComponent: No licenseFlag provided in query params.');
      return;
    }

    if (context === 'code-search') {
      this.text = 'CODE_SEARCH.NOT_AVAILABLE_TEXT';
      this.subText = 'CODE_SEARCH.NOT_AVAILABLE_SUBTEXT';
    } else if (this.licenseTextMappings[licenseFlag]) {
      const mapping = this.licenseTextMappings[licenseFlag];
      this.text = mapping.text;
      this.subText = mapping.subText;
    }
  }

  public learnMoreClicked(): void {
    const url = 'https://elements.cloud/your-journey-with-elements-cloud/';

    window.open(url, '_blank');
  }
}
